import {
  AppLayout,
  DressCodeSection,
  GallerySection,
  GiftsSection,
  HeroSection,
  MusicSection,
  ScrollToTop,
  TimelineSection,
  WeddingInfoSection,
} from './components';

function App() {
  return (
    <>
      <AppLayout>
        <HeroSection />
        <WeddingInfoSection />
        <TimelineSection />
        <MusicSection />
        <GiftsSection />
        {/* <DressCodeSection /> */}
        <GallerySection />
      </AppLayout>
      <ScrollToTop />
    </>
  );
}

export default App;
